import styled from "@emotion/styled";
import type { ButtonProps } from "@radix-ui/themes";
import type React from "react";

import { theme } from "@themes/themes";

import { Button } from "@src/ui-kit/Button";

interface LongShortButtonProps {
  variant?: "long" | "short";
  className?: string;
  children: React.ReactNode;
}

export const LongShortButton: React.FC<LongShortButtonProps & Omit<ButtonProps, "variant">> = ({
  variant,
  children,
  className,
  ...rest
}) => {
  return (
    <ButtonStyled className={className} data-direction={variant} {...rest}>
      {children}
    </ButtonStyled>
  );
};

const ButtonStyled = styled(Button)`
  --btn-bg: ${theme.color("green-weak")};
  --btn-color: ${theme.color("green-strong")};
  --btn-border: ${theme.color("green-strong")};

  &[data-direction="short"] {
    --btn-bg: ${theme.color("red-weak")};
    --btn-color: ${theme.color("red-strong")};
    --btn-border: ${theme.color("red-strong")};
  }

  background: var(--btn-bg);
  color: var(--btn-color);
  border: 1px solid var(--btn-border);

  border-radius: 8px;

  &:hover {
    background: var(--btn-bg);
    color: var(--btn-color);
    border: 1px solid var(--btn-border);
  }
`;
